import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`Este es el repositorio principal de nuestro grupo de computación visual del 2020-02 donde publicaremos las entregas principales.
El Curso de Computación Visual comenzo el Lunes 24 de Agosto del 2020 bajo la dirección del maestro Jean Pierre Charalambos Hernandez. `}</p>
    <p>{`Ademas esta plantilla de Gatsby es el tema: `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.com/starters/LekoArts/gatsby-starter-portfolio-cara"
      }}>{`https://www.gatsbyjs.com/starters/LekoArts/gatsby-starter-portfolio-cara`}</a>{` a los cual estamos muy agradecidos,
y el credito de la interfaz es de ellos. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      